// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import PromotionForm from '../../common/PromotionForm';
import { DateUtils } from '../../../../../common/utils';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    minHeight: '500px',
    paddingTop: theme.spacing(3),
  },
}));

function PromotionDetailsPage(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const {
    promotion,
    products,
    onUpdatePromotion,
    onGoBack,
    actionsDisabled,
    onClosePromotion,
  } = props;

  return (
    <Box id="PromotionDetailsTab-container" className={classes.container}>
      <PromotionForm
        promotion={promotion}
        products={products}
        onSave={onUpdatePromotion}
        onCancel={onGoBack}
        cancelButtonText={t('common.back')}
        cancelButtonIcon="chevron_left"
        actionsDisabled={actionsDisabled}
        onClosePromotion={onClosePromotion}
        editMode
      />
    </Box>
  );
}

PromotionDetailsPage.propTypes = {
  promotion: PropTypes.shape({
    id: PropTypes.number,
    code: PropTypes.string,
    discountDuration: PropTypes.number,
    discountType: PropTypes.String,
    discountValue: PropTypes.number,
    description: PropTypes.string,
    periods: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
      })
    ),
  }).isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  onUpdatePromotion: PropTypes.func.isRequired,
  onClosePromotion: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
  actionsDisabled: PropTypes.bool.isRequired,
};

export default PromotionDetailsPage;
